import { mapKeysToSnakeCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_ASSET } from '@/resources/api-routes'
import { post } from '@/util/auth'

import type { ResultStatusOriginal } from './types'

export const updateAsset = async ({
  id,
  payload,
}: {
  id: number
  payload: {
    typeId: number | string | null
    statusId: number | string
    userTypeId: number | string
    ownershipTypeId: number | string | null
    returnStatusId: number | null
    costObjectId: number | string | null
    customerId: number | null
    assetDescription: string | null
    imei: string | null
    snr: string | null
    cost: number
    received: string
    leaseStart: string | null
    leaseEnd: string | null
    deleteCertificate: boolean
    deleteCertificateDate: string
    result: ResultStatusOriginal | null
    resultCost: number
    comment: string
    userName?: string | null
    ecomPolicyId?: number
  }
}) => {
  const snakeCasePayload = mapKeysToSnakeCase(payload)
  return post<null>(API_ROUTE_ADMIN_ASSET.replace(':assetId', String(id)), snakeCasePayload)
}
